import React from 'react'
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom'
import UserManual from '@ms/shared/components/archives/user_manual'
import NotFound from './components/http_error/404'
import lodash from 'lodash'
import Register from './components/auth/register'
import ResetPassword from './components/auth/reset_password'
import GoogleLogin from './components/auth/google'
import AuthRedeemResetPasswordTokenFrm from './components/auth/redeem_reset_password_token_frm'
import VerifyCode from './components/auth/verify_code'
import StudentOnboarding from './components/auth/student_onboarding'
import TeacherOnboarding from './components/auth/teacher_onboarding'
import MainLogin from './components/auth/main_login'
import {
	getUserInfo,
} from './services/auth_storage'

const App = () => {
	console.log('Router called..')


	let user_info = null
	let is_admin = false
	const storedUserInfo = getUserInfo()
	if (Object.keys(storedUserInfo).length > 0) {
		try {
			user_info = storedUserInfo
			console.log('user_info router...', user_info)

			let chk_role = lodash.filter(user_info.roles, { id: 1 })
			if (chk_role.length > 0) is_admin = true
		} catch (e) {}

		console.log('is_admin : ', is_admin)
	}

	return (
		<Router>
			<Routes>
				<Route path='/' element={<MainLogin />} />
				<Route path='/main_login' element={<MainLogin />} />
				<Route path='/google_login/auth/google' element={<GoogleLogin />} />
				<Route path='/google_login/student_onboarding' element={<StudentOnboarding />} />
				<Route path='/google_login/teacher_onboarding' element={<TeacherOnboarding />} />
				<Route path='/login' element={<MainLogin />} />
				<Route path='/verify' element={<VerifyCode/>} />
					{ process.env.REACT_APP_ALLOW_SELF_REGISTER === 'true' && 
						<>
							<Route path='/register' element={<Register />} />
							<Route path='/reset_password' element={<ResetPassword />} />
							<Route path='/reset_password/:token' element={<AuthRedeemResetPasswordTokenFrm />} />
						</>
					}

				<Route path='/usermanual' element={<UserManual />} />
				<Route path='*' element={<NotFound />} />
			</Routes>
		</Router>
	)
}

export default App
